import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AccountService} from '../../account/account.service';
import {CampaignService} from '../campaign.service';
import {CommonDataService} from '../../shared/services/common-data.service';
import {SettingsService} from '../../settings/settings.service';
import {FundraiserOrderMaterialsService} from '../../orders/materials/fundraiser-order-materials.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ScrollTopService} from '../../shared/services/scroll-top.service';

@Component({
    selector: 'app-campaign-manage',
    templateUrl: './campaign-manage.component.html',
    styleUrls: ['./campaign-manage.component.css']
})
export class CampaignManageComponent implements OnInit {

    msg = [];
    startDate;
    campaignName;
    formGroup: FormGroup;
    currentUser;
    nonProfit: Boolean;
    orgType: String;
    campaign;
    orders: any [] = [];
    hasOrders = false;
    productName: String;
    resourceList = [];
    resourceListSchool = [];
    resourceListNonprofit = [];
    resourceUri = '/assets/downloads/fundraising/';
    resourceThumbUri = 'thumbnails/';

    orderDTO = {
        'campaignId': null,
        'qtyForms': null,
        'qtyMemberships': null,
        'requestBanner': null,
        'specialInstructions': null,
        'shipToContact': null,
        'shipToAddress': null,
        'shipToCity': null,
        'shipToState': null,
        'shipToZipcode': null,
        'orderType': null,
        'billingType': null,
        'totalDueOrder': null
    };

    constructor(private router: Router,
                private accountService: AccountService,
                private campaignService: CampaignService,
                private cdService: CommonDataService,
                private settingsService: SettingsService,
                private ordersService: FundraiserOrderMaterialsService,
                private route: ActivatedRoute,
                private scrollTopService: ScrollTopService) {

        this.formGroup = new FormGroup({
            'qtyForms': new FormControl(''),
            'qtyMemberships': new FormControl(''),
            'requestBanner': new FormControl(''),
            'specialInstructions': new FormControl(''),
            'shipToContact': new FormControl('', Validators.required),
            'shipToAddress': new FormControl('', Validators.required),
            'shipToCity': new FormControl('', Validators.required),
            'shipToState': new FormControl('', Validators.required),
            'shipToZipcode': new FormControl('', Validators.required),
            'checkOrganizationAddress': new FormControl('')
        });

        this.resourceListSchool = [
            {
                'file': 'axxess-fundraising-manual.pdf',
                'label': 'axxess-fundraising-manual',
                'title': 'Fundraising Manual'
            },
            {
                'file': 'axxess-coming-soon.pdf',
                'label': 'axxess-coming-soon',
                'title': 'Coming Soon Flyer'
            },
            {
                'file': 'axxess-going-on-now.pdf',
                'label': 'axxess-going-on-now',
                'title': 'Going On Now Flyer'
            },
            {
                'file': 'axxess-teacher-instructions.pdf',
                'label': 'axxess-teacher-instructions',
                'title': 'Teacher Instructions'
            },
            {
                'file': 'axxess-teacher-reminder.pdf',
                'label': 'axxess-teacher-reminder',
                'title': 'Teacher Reminder'
            },
            {
                'file': 'axxess-support-our-school.pdf',
                'label': 'axxess-support-our-school',
                'title': 'Support Our School'
            },
            {
                'file': 'axxess-order-form.pdf',
                'label': 'axxess-order-form',
                'title': 'Order Form'
            },
            {
                'file': 'axxess-sales-sheet.pdf',
                'label': 'axxess-sales-sheet',
                'title': 'Sales Sheet (PDF)'
            },
            {
                'file': 'axxess-sales-sheet.xlsx',
                'label': 'axxess-sales-sheet',
                'title': 'Sales Sheet (XLSX)'
            },
            {
                'file': 'axxess-reconciliation.pdf',
                'label': 'axxess-reconciliation',
                'title': 'Reconciliation Instructions'
            }
        ];

        this.resourceListNonprofit = [
            {
                'file': 'axxess-coming-soon.pdf',
                'label': 'axxess-coming-soon',
                'title': 'Coming Soon Flyer'
            },
            {
                'file': 'axxess-order-form.pdf',
                'label': 'axxess-order-form',
                'title': 'Order Form'
            },
            {
                'file': 'axxess-support-our-group.pdf',
                'label': 'axxess-support-our-group',
                'title': 'Support Our Group'
            },
        ];
    }

    ngOnInit() {
        this.scrollTopService.setScrollTop();

        this.settingsService.currentUser().subscribe(user => {
            this.currentUser = user;
            this.orgType = user.organizationtype.toLowerCase();
            this.resourceList = this['resourceList' + this.orgType.charAt(0).toUpperCase() + this.orgType.slice(1)];
            this.nonProfit = this.orgType === 'nonprofit';
            this.productName = this.nonProfit ? 'Memberships' : 'Packets';
        }, error => {
            console.log('Error get current user');
        });

        this.route.params.subscribe(params => {
            this.loadCampaign(params['id']);
        });
    }

    loadCampaign(id) {

        this.campaignService.getCampaign(id).subscribe(data => {

            this.campaign = data;
            this.startDate = new Date(this.campaign.startdate);
            this.campaignName = this.campaign.campaignname;
            this.campaignService.broadcastCampaignId(this.campaign.id);
            this.campaignService.broadcastCampaignStartDate(this.startDate);

            this.campaignService.getOrders(id).subscribe(data => {
                this.orders = data;
                if (this.orders.length > 0) {
                    this.hasOrders = true;
                }
            });
        }, error => {
            console.log('Not Found');
        });
    }

    validationFields() {

        // if (!this.formGroup.get('campaign').valid) {
        //     this.msg.push({severity: 'error', detail: 'Please enter a value for Select Campaign'});
        // }

        if (!this.formGroup.get('qtyForms').valid) {
            this.msg.push({severity: 'error', detail: 'Select a value for packet quantity'});
        }

        if (!this.formGroup.get('qtyMemberships').valid) {
            this.msg.push({severity: 'error', detail: 'Select a value for membership quantity'});
        }

        if (!this.formGroup.get('shipToContact').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Contact'});
        }

        if (!this.formGroup.get('shipToAddress').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Ship to Address'});
        }

        if (!this.formGroup.get('shipToCity').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for City'});
        }

        if (!this.formGroup.get('shipToState').valid) {
            this.msg.push({severity: 'error', detail: 'Please select a value for State'});
        }

        if (!/[0-9/-]+$/.test(this.formGroup.value.shipToZipcode)) {
            this.msg.push({severity: 'error', detail: 'Zipcode may only contain integers 0-9 and - character'});
        } else {
            if (!this.formGroup.get('shipToZipcode').valid) {
                this.msg.push({severity: 'error', detail: 'Please enter a value for Zipcode'});

                if (this.formGroup.value.shipToZipcode.length < 5) {
                    this.msg.push({severity: 'error', detail: 'Zipcode must be at least 5 characters'});
                }
            }
        }

    }

    isCampaignEnding(): Boolean {
        if (this.startDate === undefined) {
            return false;
        }

        const endDate = new Date(this.startDate.getTime() + 1209600000);
        return new Date().getTime() > endDate.getTime();
    }

    submit() {
        this.validationFields();
        this.submitOrder();
    }


    submitOrder() {

        if (this.formGroup.valid === false || this.msg.length > 0) {
            return;
        }

        this.orderDTO.campaignId = this.campaign.id;
        this.orderDTO.qtyForms = this.formGroup.value.qtyForms;
        this.orderDTO.qtyMemberships = this.formGroup.value.qtyMemberships;
        this.orderDTO.requestBanner = this.formGroup.value.requestBanner;
        this.orderDTO.specialInstructions = this.formGroup.value.specialInstructions;
        this.orderDTO.shipToContact = this.formGroup.value.shipToContact;
        this.orderDTO.shipToAddress = this.formGroup.value.shipToAddress;
        this.orderDTO.shipToCity = this.formGroup.value.shipToCity;
        this.orderDTO.shipToState = this.formGroup.value.shipToState;
        this.orderDTO.shipToZipcode = this.formGroup.value.shipToZipcode;
        this.orderDTO.orderType = this.nonProfit ? 1 : 0;
        this.orderDTO.billingType = 0;
        this.orderDTO.totalDueOrder = (this.formGroup.value.qtyMemberships || 0) * 27;

        const data = this.cdService.trimObjectData(this.orderDTO);

        this.ordersService.createOrder(data)
            .subscribe(
                data => {
                    this.cdService.setUnsavedChanges(false);
                    this.formGroup.reset();
                    this.loadCampaign(this.campaign.id);
                },
                error => {
                    if (error.parameterErrors !== undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else if (error.message.length !== 0) {
                        this.msg.push({severity: 'error', detail: error.message});
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign-manage/campaign-manage.component.ts